import React from 'react';
import { Link } from 'react-router-dom';

export default function Invalid() {
  const lastOrderId = window.localStorage.getItem('orderId');

  return (
    <div className="container has-text-centered">
      <div className="title mt-4">Uh Oh!</div>
      <div className="title mb-4">
        You have reached this page in error.
      </div>

      <div className="buttons has-addons is-centered">
        <Link to="/logout" className="button">
          <span>Sign Back In</span>
        </Link>
      </div>
    </div>
  )
}
